module.exports = __webpack_public_path__ + "img/photo16.ecd4f052.jpg";